import mongoose, { Model, Schema } from 'mongoose';
import { IJob } from '../interfaces/job.interface';



const JobSchema = new Schema<IJob>({
    createdDate: { type: Date, default: Date.now },
    companyName: { type: String, required: true },
    location: { type: String, required: true },
    noOfSpots: { type: Number, required: true, min: 1 },
    allotted: { type: Number, default: 0 },
    open: {
        type: Number,
        default: function (this: IJob) { return this.noOfSpots; },
        min: 0
    },
    status: { type: String, enum: ['Open', 'Closed'], default: 'Open' },
    note: { type: String, default: '' },
    createdBy: { type: Schema.Types.ObjectId, ref: 'User' },
    isDeleted: { type: Boolean, default: false },
    deletedAt: { type: Date, default: null },
    updatedAt: { type: Date },
    srno: { type: String }
}, { timestamps: true, versionKey: false });


JobSchema.index({ companyName: 1, location: 1 })

const Job: Model<IJob> = mongoose.model<IJob>('Job', JobSchema);

export default Job